<template>
  <v-col cols="12" xl="6" lg="4" md="4" sm="12" class="px-2 my-2" style="flex-wrap: nowrap">
    <v-card :loading="loading" style="height: inherit; padding: 4px">
      <v-list-item @click="handleSelectionClick" :disabled="disabled" :class="selected ? 'selected' : ''">
        <!-- image of the hall -->
        <slot name="avatar">
          <v-list-item-avatar size="64px">
            <slot name="avatar">
              <v-img height="100%" :src="previewImage" />
            </slot>
          </v-list-item-avatar>
        </slot>

        <v-list-item-content>
          <!-- name of the hall -->
          <v-list-item-title>
            <v-row no-gutters style="align-items: center; flex-wrap: wrap; height: 64px">
              <v-col cols="auto" style="vertical-align: middle">
                <p class="ma-0">
                  {{ hall.Title }}
                </p>
              </v-col>
              <v-col cols="auto" class="d-flex ml-1">
                <Tag
                  v-for="(tag, index) of getHallBookedAndPayedTags(hall)"
                  :tagCount="2"
                  :key="'tag_bookedPayedHallPrev' + hall.Id + '_' + index"
                  :tagInfo="tag" />
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- tags -->
      <v-row no-gutters class="mt-1 px-4">
        <v-slide-group show-arrows>
          <Tag v-for="(tag, index) of hall.tags" :tagCount="hall.tags.length" :key="'tag_hallPrev' + hall.Id + '_' + index" :tagInfo="tag" />
        </v-slide-group>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
// vuex
import { mapGetters } from 'vuex';
import { GET_SESSIONDATA } from '@/store/storeMutator.js';

// mixins
import HelpersMixin from '@/mixins/helpers.js';
import TagsMixin from '@/mixins/tags.js';

// components
import Tag from '@/components/controls/Tag.vue';

// assets
import placeholderImg from '@/assets/img/placeholder.jpg';

export default {
  name: 'HallPreviewItem',

  props: {
    hallId: String,
    selected: Boolean,
    disabled: Boolean,
    loading: Boolean,
  },

  emits: ['onSelect'],

  mixins: [HelpersMixin, TagsMixin],

  components: {
    Tag,
  },

  methods: {
    handleSelectionClick() {
      this.$emit('onSelect', this.hall);
    },
  },

  computed: {
    ...mapGetters({ SessionData: GET_SESSIONDATA }),

    hall() {
      return this.SessionData.club.halls.filter((hall) => hall.Id == this.hallId)[0];
    },

    /** returns the image for the current preview, if available (otherwise placeholder image) */
    previewImage() {
      if (!this.isNoWs(this.hall.Image)) {
        return this.base64ImgPrefix + this.hall.Image;
      } else {
        return placeholderImg;
      }
    },
  },
};
</script>

<style scoped>
.listitem-info-container {
  /* behavior */
  display: flex;
  /* flex properties */
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.info-icon {
  flex: 0 0 max-content;
}

.info-content {
  /* behavior */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* flex properties */
  flex: 1 1 auto;
}
</style>
